import React from 'react'
import { TextField } from 'office-ui-fabric-react'

export function R2B2ReplacementForm({
  integrationTypeConfig,
  onIntegrationTypeConfigChange,
  disabled,
  errorCode,
}: {
  integrationTypeConfig: any
  onIntegrationTypeConfigChange: (config: any) => void
  disabled: boolean
  errorCode: string
}) {
  return (
    <>
      <TextField
        label="R2B2 Placement Code"
        placeholder="<script src='//delivery.r2b2.io/...'></script>"
        errorMessage={errorCode === 'invalidCode' ? 'Invalid code' : ''}
        value={integrationTypeConfig.code || ''}
        autoComplete="off"
        readOnly={false}
        disabled={disabled}
        multiline={true}
        rows={5}
        onChange={(
          _event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
          newValue?: string
        ): void => {
          onIntegrationTypeConfigChange({
            ...integrationTypeConfig,
            code: newValue || '',
          })
        }}
      />
      <TextField
        label="R2B2 Placement Selector"
        placeholder="#r2b2-container"
        errorMessage={errorCode === 'invalidSelector' ? 'Invalid selector' : ''}
        value={integrationTypeConfig.selector || ''}
        autoComplete="off"
        readOnly={false}
        disabled={disabled}
        onChange={(
          _event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
          newValue?: string
        ): void => {
          onIntegrationTypeConfigChange({
            ...integrationTypeConfig,
            selector: newValue || '',
          })
        }}
      />
    </>
  )
}
